import React from 'react';
import { useMessage } from '../contexts/MessageContext';

const MessageDisplay = () => {
  const { messages, removeMessage } = useMessage();

  // Función para obtener las clases CSS según el tipo de mensaje
  const getMessageClasses = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative dark:bg-green-900 dark:border-green-700 dark:text-green-200';
      case 'error':
        return 'bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative dark:bg-red-900 dark:border-red-700 dark:text-red-200';
      case 'warning':
        return 'bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative dark:bg-yellow-900 dark:border-yellow-700 dark:text-yellow-200';
      case 'info':
      default:
        return 'bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative dark:bg-blue-900 dark:border-blue-700 dark:text-blue-200';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 w-80 max-w-[calc(100vw-2rem)]">
      {messages.map((message) => (
        <div key={message.id} className={getMessageClasses(message.type)}>
          <span className="block sm:inline">{message.text}</span>
          <span 
            className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer"
            onClick={() => removeMessage(message.id)}
          >
            <svg className="w-6 h-6 text-current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </span>
        </div>
      ))}
    </div>
  );
};

export default MessageDisplay;
